package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class BagResponseItem(
    val id: Long? = null,
    val merchantLocationId: Long? = null,
    val locationName: String? = null,
    val title: String? = null,
    val availableCount: Int? = null,
    val totalCount: Int? = null,
    val priceWithDiscount: Double? = null,
    val currency: String? = null,
    val activeTo: String? = null,
    val activeFrom: String? = null,
    val createdAt: String? = null,
)

@Serializable
data class GetMerchantBagsResponseModel(
    val bags: List<BagResponseItem> = emptyList(),
    val locations: List<MerchantLocationResponseModel> = emptyList()
) : BaseResponseModel()

